module.exports = __webpack_public_path__ + "img/RSG-logo.1ceb6389.png";